import { render } from "./IpAddressesTab.vue?vue&type=template&id=3eebafce&scoped=true"
import script from "./IpAddressesTab.vue?vue&type=script&lang=js"
export * from "./IpAddressesTab.vue?vue&type=script&lang=js"

import "./IpAddressesTab.vue?vue&type=style&index=0&id=3eebafce&lang=scss&scoped=true"

import exportComponent from "/home/pedro/git/cloudstack/scclouds/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eebafce"]])

export default __exports__